const routes = {
  home: '/',
  rates: '/rates/',
  taxes: '/taxes/',
  estimate: '/estimate/',
  history: '/history/',
  billing: '/history/billing/',
  error: '/404/',
  privacy: '/privacy/',
  term: '/term-of-service/',
}

const auth0 = {
  domain: process.env.GATSBY_AUTH0_DOMAIN,
  clientId: process.env.GATSBY_AUTH0_CLIENT_ID,
  callback: process.env.GATSBY_AUTH0_CALLBACK,
  orgArena: process.env.GATSBY_AUTH0_ORG_ARENA,
  conMember: process.env.GATSBY_AUTH0_CON_MEMBER,
  conCustomer: process.env.GATSBY_AUTH0_CON_CUSTOMER,
  audience: process.env.GATSBY_AUTH0_AUDIENCE,
}

const CategoryId = {
  FacilityId: 1,
  ElectricId: 2,
  FixtureId: 3,
  WaterId: 4,
}
// 10: 概算見積、20: 正式見積依頼中、30: 正式見積作成済、40: 正式見積、

// 50：承認済、60：請求書
const statusCodeText = {
  100: '概算見積',
  110: '概算見積▶依頼中',
  120: '概算見積▶正式版完了',
  200: '正式見積',
  300: '請求書',
  310: '請求書▶承認済',
}

// 「請求書」のTextは管理者と一般で異なるので注意
// 一般からすると請求書は承認済、未承認の区別がないためこのようにしている
const statusCodeTextForGeneral = {
  100: '概算見積',
  110: '概算見積▶依頼中',
  120: '概算見積▶正式版完了',
  200: '正式見積',
  310: '請求書',
}

const statusCode = {
  概算見積: 100,
  正式見積依頼中: 110,
  正式見積作成済: 120,
  正式見積: 200,
  請求書: 300,
  請求書承認済: 310,
}

const getStatusCodeArray = Object.entries(statusCodeText).map(([value, text]) => ({
  value: Number(value),
  text,
}))

const getStatusCodeArrayForGeneral = Object.entries(statusCodeTextForGeneral).map(
  ([value, text]) => ({
    value: Number(value),
    text,
  })
)

const serverErrorMessage =
  '処理中です。しばらくお待ちください。問題が解決しない場合は、システム管理者にご連絡ください。'

const getStatusCodeText = (StatusCode: number) => {
  switch (StatusCode) {
    case 100:
      return statusCodeText[100]
    case 110:
      return statusCodeText[110]
    case 120:
      return statusCodeText[120]
    case 200:
      return statusCodeText[200]
    case 300:
      return statusCodeText[300]
    case 310:
      return statusCodeText[310]
  }
  return ''
}

const getConfirmationTitle = (StatusCode: number) => {
  if (StatusCode === 300 || StatusCode === 310) {
    return '請求情報'
  } else {
    return '見積情報'
  }
}

const config = {
  statusCode,
  getStatusCodeArray,
  routes,
  auth0,
  CategoryId,
  getStatusCodeText,
  getStatusCodeArrayForGeneral,
  getConfirmationTitle,
  serverErrorMessage,
}

export default config
